import { render, staticRenderFns } from "./InquiriesList.vue?vue&type=template&id=7dacacd6&"
import script from "./InquiriesList.vue?vue&type=script&lang=ts&"
export * from "./InquiriesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports